import { Spinner } from "@repo/ui4/components/Spinner";
import { cn } from "@repo/ui4/lib/utils";
import { type ComponentProps, useEffect, useState } from "react";

type Props = ComponentProps<"div"> & {
  size?: "screen";
  withDelay?: number;
};

export const LoadingBox = ({
  className,
  size,
  withDelay = 0,
  ...props
}: Props) => {
  const [isVisible, setIsVisible] = useState(withDelay <= 0);

  useEffect(() => {
    if (withDelay <= 0) {
      setIsVisible(true);
      return;
    }
    setIsVisible(false);
    const timer = window.setTimeout(() => setIsVisible(true), withDelay);
    return () => window.clearTimeout(timer);
  }, [withDelay]);

  return (
    <div
      className={cn(
        "flex items-center justify-center py-16 text-muted-foreground",
        size === "screen" && "min-h-dvh",
        !isVisible && "invisible",
        className,
      )}
      {...props}
    >
      <Spinner size="lg" aria-label="読み込み中" />
    </div>
  );
};
